import { i18n } from 'i18next';

type MenuAction = {
  onClickCancel: () => void;
  onClickResend: () => void;
  isCancelButtonDisabled: boolean;
  isResendButtonDisabled: boolean;
};

type ShowCurrent = {
  isReadOnly: boolean;
  isResendButtonDisabled: boolean;
  isCancelButtonDisabled: boolean;
};

const menuOptions = (i18n: i18n) => [
  {
    index: 1,
    icon: 'ni-send',
    text: i18n.t('Resend'),
    action: ({ onClickResend }: MenuAction) => {
      onClickResend();
    },
    dontShowCurrent: ({ isReadOnly, isResendButtonDisabled }: ShowCurrent) =>
      isReadOnly || isResendButtonDisabled,
  },
  {
    index: 2,
    icon: 'ni-cross',
    text: i18n.t('Cancel'),
    action: ({ onClickCancel }: MenuAction) => onClickCancel(),
    dontShowCurrent: ({ isReadOnly, isCancelButtonDisabled }: ShowCurrent) =>
      isReadOnly || isCancelButtonDisabled,
  },
  {
    index: 3,
    icon: 'ni-trash',
    text: i18n.t('Delete'),
    action: () => {},
    dontShowCurrent: () => true,
  },
];

export default menuOptions;
